import { Component, ViewChild } from '@angular/core';
import { NavController, Tabs, Platform, Content, MenuController } from 'ionic-angular';
import { CustomerOverviewPage } from '../customer-overview/customer-overview';
import { TrainOverviewPage } from '../train-overview/train-overview';
import { ReportsPage } from '../reports/reports';
import { LogBookPage } from '../log-book/log-book';
import { NotificationsPage } from '../notifications/notifications';
import { NavEntity } from '../../models';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ApplicationApiProvider } from '../../providers/application-api/application-api';
import { StarmsClientProvider } from '../../providers/starms-client/starms-client';
import { TimeProvider } from '../../providers/time/time';
import Enumerable from 'linq';
import { EntitiesProvider } from '../../providers/entities/entities';
import { TemplateProvider } from '../../providers/template/template';

const notificationsDate = '2014-01-01';

@Component({
  selector: 'page-entity',
  templateUrl: 'entity.html'
})
export class EntityPage {
  @ViewChild('mycontent') tabRef: Tabs;
  @ViewChild(Content) content: Content;

  nav: NavEntity;
  overviewRoot: any;
  reports: any = ReportsPage;
  logs: any = LogBookPage;
  notificationsCount = 0;
  notifications: BehaviorSubject<Array<any>> = new BehaviorSubject<
    Array<any>
  >([]);
  templateConfig: any;

  constructor(
    public navCtrl: NavController,
    public platform: Platform,
    private menuController: MenuController,

    private appApi: ApplicationApiProvider,
    private starms: StarmsClientProvider,
    private time: TimeProvider,
    private entitiesProvider: EntitiesProvider,
    private templateProvider: TemplateProvider
  ) {
    this.nav = this.entitiesProvider.currentEntity;

    // Insert the entity tab page depending on entity type
    if (this.nav.getType() === 'customer') {
      this.overviewRoot = CustomerOverviewPage;
    } else if (this.nav.getType() === 'train') {
      this.overviewRoot = TrainOverviewPage;
    }

    this.getTemplate();
  }

  ionViewDidLoad(): void {
    this.menuController.close('nav');

    // Get notifications
    this.starms.get(['notificationdocuments/documents', this.entitiesProvider.currentEntity.getType() + 's',
    this.entitiesProvider.currentEntity.getId()], {
      from: notificationsDate,
      to: this.time.add(this.time.get(), 1, 'd')
    }).subscribe(notifications => {
      this.notifications.next(Enumerable.from(notifications)
        .orderByDescending(x => x['creationDate'])
        .toArray());
      this.notificationsCount = this.notifications
        .getValue()
        .filter(notifiation => notifiation['archived'] === false).length;
    });
  }

  openNotificationsModal(): void {
    this.navCtrl.push(NotificationsPage, {
      data: {
        id: this.nav.getId(),
        type: this.nav.getType()
      }
    });
  }

  openMenu(): void {
    this.menuController.open('nav');
  }

  getTemplate(): void {
    this.templateConfig = {
      notifications: this.templateProvider.currentTemplate.Notifications,
      reports: this.templateProvider.currentTemplate.Reports,
      logBook: this.templateProvider.currentTemplate.LogBook
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/entity/entity.ts